/**
 * Frontend Layout Globals
 * ========================
 * Extracted from frontend/layouts/app.blade.php
 *
 * Handles:
 * - Flash messages from Laravel session (via data attributes)
 * - Global helper functions (confirmDelete, showSuccess, showError)
 * - Unified toggleFavorite() with axios and event delegation
 * - Google Analytics legacy snippet
 */

import axios from 'axios';
import { AlertManager, Swal } from '../sweetalert-config.js';

// =============================================
// FLASH MESSAGES (from Laravel session)
// =============================================

function initFlashMessages() {
    const flashDiv = document.getElementById('flash-messages');
    if (!flashDiv) return;

    const success = flashDiv.dataset.success;
    const error = flashDiv.dataset.error;
    const warning = flashDiv.dataset.warning;
    const info = flashDiv.dataset.info;

    if (success) AlertManager.toast(success, 'success');
    if (error) AlertManager.toast(error, 'error');
    if (warning) AlertManager.toast(warning, 'warning');
    if (info) AlertManager.toast(info, 'info');
}

// =============================================
// GLOBAL HELPER FUNCTIONS
// =============================================

window.confirmDelete = function(message) {
    return AlertManager.confirmDelete(message);
};

window.showSuccess = function(message) {
    return AlertManager.toast(message, 'success');
};

window.showError = function(message) {
    return AlertManager.toast(message, 'error');
};

// =============================================
// UNIFIED TOGGLE FAVORITE
// =============================================

/**
 * Toggle favorite status for a file or folder.
 * Unifies the three previous inline implementations.
 *
 * @param {number|string} elementId - The file/folder ID
 * @param {string} tipo - 'archivo'|'file' or 'carpeta'|'folder' (default: 'archivo')
 */
window.toggleFavorite = function(elementId, tipo) {
    tipo = tipo || 'archivo';
    console.log('🔄 Iniciando toggle de favorito:', { id: elementId, tipo: tipo });

    // Find the button - support both layout (data-id + data-tipo) and history (tr[data-archivo-id] .btn-favorite) patterns
    let button = document.querySelector(`[data-id="${elementId}"][data-tipo="${tipo}"].addFav`);
    if (!button) {
        button = document.querySelector(`[data-id="${elementId}"].addFav`);
    }
    if (!button) {
        button = document.querySelector(`tr[data-archivo-id="${elementId}"] .btn-favorite`);
    }
    if (!button) {
        console.error('❌ Botón de favorito no encontrado:', { id: elementId, tipo: tipo });
        return;
    }

    // Show loading state
    const icon = button.querySelector('i');
    const originalClass = icon ? icon.className : '';
    if (icon) {
        icon.className = 'fa fa-spinner fa-spin fa-2x';
    }
    button.disabled = true;

    // Build request data
    const data = {};
    if (tipo === 'folder' || tipo === 'carpeta') {
        data.carpeta_id = elementId;
        data.tipo = 'carpeta';
    } else {
        data.archivo_id = elementId;
        data.tipo = 'archivo';
    }

    // Get the favorites toggle URL from meta tag
    const favoritesUrl = document.querySelector('meta[name="favorites-toggle-url"]')?.content;
    if (!favoritesUrl) {
        console.error('❌ Meta tag "favorites-toggle-url" no encontrado');
        if (icon) icon.className = originalClass;
        button.disabled = false;
        return;
    }

    console.log('📡 Enviando petición a:', favoritesUrl);

    // Make request with axios
    axios.post(favoritesUrl, data, {
        headers: {
            'Accept': 'application/json'
        }
    })
    .then(function(response) {
        const responseData = response.data;
        console.log('📋 Datos de respuesta:', responseData);

        if (responseData.success) {
            if (responseData.is_favorite) {
                button.classList.add('active');
                if (icon) icon.className = 'fa fa-star fa-2x';
                console.log('✅ Favorito agregado');
            } else {
                button.classList.remove('active');
                if (icon) icon.className = 'far fa-star fa-2x';
                console.log('✅ Favorito removido');
            }
        } else {
            console.error('❌ Error del servidor:', responseData.message);
            if (icon) icon.className = originalClass;
            if (window.AlertManager) {
                AlertManager.error('Error', responseData.message || 'Error al actualizar favorito');
            }
        }
    })
    .catch(function(error) {
        console.error('❌ Error de red:', error);
        if (icon) icon.className = originalClass;
        if (window.AlertManager) {
            AlertManager.error('Error de conexión', 'No se pudo actualizar el favorito. Por favor, intente nuevamente.');
        }
    })
    .finally(function() {
        button.disabled = false;
    });
};

// Event delegation for .addFav buttons (from layout)
document.addEventListener('click', function(e) {
    let element = e.target;
    while (element && element !== document) {
        if (element.classList && element.classList.contains('addFav')) {
            e.preventDefault();
            const elementId = element.dataset.id;
            const tipo = element.dataset.tipo || 'archivo';
            if (elementId) {
                console.log('🖱️ Click en favorito detectado:', { id: elementId, tipo: tipo });
                window.toggleFavorite(elementId, tipo);
            }
            return;
        }
        element = element.parentElement;
    }
});

// =============================================
// GOOGLE ANALYTICS (legacy)
// =============================================

function initGoogleAnalytics() {
    var _gaq = window._gaq || [];
    _gaq.push(['_setAccount', 'UA-37105156-1']);
    _gaq.push(['_trackPageview']);
    window._gaq = _gaq;

    (function(d, t) {
        var g = d.createElement(t);
        var s = d.getElementsByTagName(t)[0];
        g.src = ('https:' === location.protocol ? '//ssl' : '//www') + '.google-analytics.com/ga.js';
        s.parentNode.insertBefore(g, s);
    }(document, 'script'));
}

// =============================================
// INITIALIZE
// =============================================

document.addEventListener('DOMContentLoaded', function() {
    initFlashMessages();
    initGoogleAnalytics();
    console.log('🚀 Frontend layout globals inicializados');
});
